import * as React from 'react'
import colors from 'theme/colors'

const SvgComponent = ({
  color = colors.borderGrey,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 27
  const h = 27
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00297 3.87109C6.46967 3.87109 4.41602 5.92474 4.41602 8.45805V17.7841C4.41602 20.3174 6.46967 22.3711 9.00297 22.3711H18.3291C20.8624 22.3711 22.916 20.3174 22.916 17.7841V8.45805C22.916 5.92474 20.8624 3.87109 18.3291 3.87109H9.00297ZM3.41602 8.45805C3.41602 5.37246 5.91738 2.87109 9.00297 2.87109H18.3291C21.4146 2.87109 23.916 5.37246 23.916 8.45805V17.7841C23.916 20.8697 21.4146 23.3711 18.3291 23.3711H9.00297C5.91738 23.3711 3.41602 20.8697 3.41602 17.7841V8.45805ZM13.666 9.55859C11.6985 9.55859 10.1035 11.1536 10.1035 13.1211C10.1035 15.0886 11.6985 16.6836 13.666 16.6836C15.6335 16.6836 17.2285 15.0886 17.2285 13.1211C17.2285 11.1536 15.6335 9.55859 13.666 9.55859ZM9.10352 13.1211C9.10352 10.6013 11.1462 8.55859 13.666 8.55859C16.1858 8.55859 18.2285 10.6013 18.2285 13.1211C18.2285 15.6409 16.1858 17.6836 13.666 17.6836C11.1462 17.6836 9.10352 15.6409 9.10352 13.1211ZM20.5723 7.43359C20.5723 8.10669 20.0266 8.65234 19.3535 8.65234C18.6804 8.65234 18.1348 8.10669 18.1348 7.43359C18.1348 6.7605 18.6804 6.21484 19.3535 6.21484C20.0266 6.21484 20.5723 6.7605 20.5723 7.43359Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
